module.exports = __webpack_public_path__ + "media/images/flags/so-d1a7d3e18523bf69f2eb0470b89b7622.svg";